import React, { useEffect, useState, useRef } from 'react';
import Select from 'react-select';
import "../priceComp.css"
import ApiService from '../../../services/apiService';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { RxCross2 } from "react-icons/rx";
import moment from 'moment';
import { FaAngleLeft } from "react-icons/fa6";
import { ClipLoader } from 'react-spinners';
import { FaSave } from "react-icons/fa";
import { getCompany, getUserId, getUserName } from '../../../../Redux/selecters';
import { useDispatch, useSelector } from 'react-redux';
import { clearComparison } from '../../../../Redux/actions/comparisonAction';
import { useCurrency } from '../../../Layouts/currencyContext';
import UpdateAttachment from '../../Attachment/UpdateAttachment';


const createEmptyRow = () => ({
    id: Date.now() + Math.random(),
    file: null,
    fileName: "",
    remarks: "",
});
const PriceCompView = () => {
    const location = useLocation();
    const CompareData = location.state;
    const dispatch = useDispatch();
    const supplierContainerRef = useRef(null);
    const itemsContainerRef = useRef(null);
    const scrollSyncRef = useRef(null);
    const [suppliersTotals, setSuppliersTotals] = useState({});
    let navigate = useNavigate();
    const [loader, setloader] = useState(false)
    const [rows, setRows] = useState([]);
    const userId = useSelector(getUserId);
    const { currencyPrecision } = useCurrency();
    const userName = useSelector(getUserName);
    const Company = useSelector(getCompany);
    const [formData, setFormData] = useState({
        QuoteNo: "",
        RequisitionNo: "",
        remarks: "",
        costCenter1: "",
        costCenter2: "",
        costCenter3: "",
        costCenter4: "",
        quotation: [
            { refNo: "", paymentTerms: "", supplier: "", remarks: "" },
            { refNo: "", paymentTerms: "", supplier: "", remarks: "" }
        ]
    });
    const [RequisitionNo, setRequisitionNo] = useState();
    const [QuotationNo, setQuotationNo] = useState();
    const apiService = new ApiService()
    const [SupplierTab, setSupplierTab] = useState(true);
    const [CostTab, setCostTab] = useState(false);
    // Attachment
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [preview, setPreview] = useState();
    const [attachments, setAttachments] = useState([createEmptyRow()]);
    const handleOpen = () => setAttachmentModal(true);
    const closeModal = () => setAttachmentModal(false);
    const [suppliers, setSupplier] = useState([]);
    const [payments, setPayments] = useState([]);

    const mapAttachmentsFromApi = (apiData) => {
        const validFiles = apiData.filter(
            a => a.fileName && a.fileName.trim() !== ""
        );

        return [
            ...validFiles.map(item => ({
                id: Date.now() + Math.random(), // UI id
                dbId: item.rcno,                // backend id
                file: null,                     // existing file (no File object)
                fileName: item.fileName,
                remarks: item.remarks || "",
                isNew: false,
                isDeleted: false,
            })),
            createEmptyRow()
        ];
    };
    useEffect(() => {
        setLoading(true)
        debugger

        if (CompareData.doctype === "Price Comparison") {
            const fetchCompareData = async () => {
                try {
                    let pcParam = `?PCNo=${CompareData.docno}`
                    const pcresponse = await apiService.getApiParamater('GET_PC', pcParam);
                    const selectedPc = pcresponse.data.result?.find(rec => rec.pcNo === CompareData.docno)

                    setRequisitionNo(selectedPc?.requisitionNo);
                    setQuotationNo(CompareData?.docno)

                    let param = `?Id=${selectedPc.requisitionNo}`
                    const response = await apiService.getApiParamater('GET_PR', param);
                    const selectedPR = response?.data?.result[0]
                    const data = selectedPc;

                    if (selectedPR?.prDetails) {
                        const formattedRows = selectedPR.prDetails.map(detail => ({
                            srno: detail.srno,
                            ItemNo: detail.itemCode,
                            recordId: detail.itemCode,
                            comparisonStatus: data.status,
                            itemDescription: detail.itemDescription,
                            Specs: detail.specification,
                            qty: detail.qty,
                            uom: detail.uom,
                            baseQty: detail.baseQty,
                            baseAmount: detail.baseAmount,
                            amount: detail.amount,
                            deliveryDate: detail.deliveryDate,
                            bol: '',
                            quotations: [{
                                itemCode: detail.itemCode,
                                qty: detail.qty,
                                unitPrice: "",
                                amount: "",
                                supplier: "",
                                paymentTerms: "",
                            },
                            {
                                itemCode: detail.itemCode,
                                qty: detail.qty,
                                unitPrice: "",
                                amount: "",
                                supplier: "",
                                paymentTerms: ""
                            }]
                        }));

                        setRows(formattedRows);
                    }

                    const transformedRows = data.priceComparisonDetails.map(item => {
                        const quotations = [];

                        for (let i = 1; i <= 6; i++) {
                            let supplier = item[`supp${i}`]?.trim();

                            if (!supplier || supplier === "string") continue;

                            quotations.push({
                                // IMPORTANT:
                                // Keep supplier column/slot information.
                                // supp1 and supp2 can have the same supplier.
                                supplierIndex: i,

                                itemCode: item.itemCode,
                                qty: item.qty,
                                selected: item[`selected${i}`],
                                unitPrice: item[`price${i}`],
                                amount: item.qty * item[`price${i}`],
                                supplierId: item[`suppId${i}`],
                                supplier: supplier,
                                paymentTerms: item[`paymentTerms${i}`],
                                refNo: item[`ref${i}`],
                                remarks: item[`remarks${i}`]
                            });
                        }

                        return {
                            srno: item.srno,
                            ItemNo: item.itemCode,
                            itemDescription: item.itemDescription,
                            Specs: item.specification,
                            qty: item.qty,
                            uom: item.uom,
                            baseQty: item.qty,
                            baseAmount: item.qty * item.price1,
                            amount: item.qty * item.price1,
                            Delivery: "",
                            bol: '',
                            quotations: quotations
                        };
                    });

                    const transformedFormData = {
                        QuoteNo: data.quoteNo,
                        RequisitionNo: data.requisitionNo,
                        remarks: "",
                        costCenter1: selectedPc.costCenter1,
                        costCenter2: selectedPc.costCenter2,
                        costCenter3: selectedPc.costCenter3,
                        costCenter4: selectedPc.costCenter4,
                        quotation: []
                    };

                    // =====================================================
                    // ONLY CHANGE:
                    // Use supplierIndex instead of supplier name.
                    //
                    // This prevents supp1 and supp2 from being considered
                    // duplicates when they have the same supplier.
                    // =====================================================
                    const selectedQuotationsMap = new Map();

                    transformedRows.forEach(row => {
                        row.quotations.forEach(quote => {

                            const key = `${quote.itemCode}-${quote.supplierIndex}`;

                            if (
                                !selectedQuotationsMap.has(key) ||
                                quote.selected === 1
                            ) {
                                selectedQuotationsMap.set(key, quote);
                            }
                        });
                    });

                    const quotations = Array.from(
                        selectedQuotationsMap.values()
                    );

                    // Keep one entry for each supplier SLOT.
                    // Do not compare supplier name or supplierId.
                    const supplierSet = new Set();
                    const filteredQuotations = [];

                    quotations.forEach(quote => {

                        const supplierKey = quote.supplierIndex;

                        if (!supplierSet.has(supplierKey)) {
                            supplierSet.add(supplierKey);
                            filteredQuotations.push(quote);
                        }
                    });

                    transformedFormData.quotation = filteredQuotations;

                    setFormData(transformedFormData);
                    setRows(transformedRows);

                    let attachparam = `?DocNo=${CompareData.docno}&DocType=${"Qutation"}`;
                    const AttachmentResponse = await apiService.getApiParamater(
                        "GET_ATTACHMENT",
                        attachparam
                    );

                    const existingAttachments =
                        AttachmentResponse?.data?.result || [];

                    if (existingAttachments) {
                        setAttachments(
                            mapAttachmentsFromApi(existingAttachments)
                        );
                    }

                    setLoading(false)

                } catch (error) {
                    setLoading(false)
                    console.error("Error fetching data:", error);
                }
            }

            fetchCompareData();

        } else if (CompareData.doctype === "Comparison") {

            const fetchCompareData = async () => {
                try {
                    let pcParam = `?PCNo=${CompareData.pcNo}`
                    const pcresponse = await apiService.getApiParamater('GET_PC', pcParam);
                    const selectedPc = pcresponse.data.result?.find(
                        rec => rec.pcNo === CompareData.pcNo
                    )

                    setRequisitionNo(CompareData?.requisitionNo);
                    setQuotationNo(CompareData.pcNo)

                    let param = `?Id=${selectedPc?.requisitionNo}`
                    const response = await apiService.getApiParamater('GET_PR', param);
                    const selectedPR = response?.data?.result[0]
                    const data = selectedPc;

                    if (selectedPR?.prDetails) {
                        const formattedRows = selectedPR.prDetails.map(detail => ({
                            srno: detail.srno,
                            ItemNo: detail.itemCode,
                            recordId: detail.itemCode,
                            comparisonStatus: data.status,
                            itemDescription: detail.itemDescription,
                            Specs: detail.specification,
                            qty: detail.qty,
                            uom: detail.uom,
                            baseQty: detail.baseQty,
                            baseAmount: detail.baseAmount,
                            amount: detail.amount,
                            deliveryDate: detail.deliveryDate,
                            bol: '',
                            quotations: [{
                                itemCode: detail.itemCode,
                                qty: detail.qty,
                                unitPrice: "",
                                amount: "",
                                supplier: "",
                                paymentTerms: ""
                            },
                            {
                                itemCode: detail.itemCode,
                                qty: detail.qty,
                                unitPrice: "",
                                amount: "",
                                supplier: "",
                                paymentTerms: ""
                            }]
                        }));

                        setRows(formattedRows);
                    }

                    const transformedRows = await Promise.all(
                        data.priceComparisonDetails.map(async (item) => {

                            const quotations = [];
                            let itemLocked = false;

                            for (let i = 1; i <= 6; i++) {

                                const supplier = item[`supp${i}`]?.trim();
                                const supplierId = item[`suppId${i}`]?.trim();

                                debugger

                                if (
                                    item[`price${i}`] &&
                                    item[`price${i}`] !== 0 &&
                                    supplier &&
                                    supplier !== "string"
                                ) {

                                    let vendorExits = 0;

                                    if (supplierId) {
                                        try {
                                            const params = new URLSearchParams();

                                            params.append(
                                                "DocNo",
                                                CompareData.requisitionNo
                                            );

                                            params.append(
                                                "Commontext",
                                                supplierId
                                            );

                                            params.append(
                                                "Action",
                                                "CheckSupplierExitsInPoForPC"
                                            );

                                            const apiResponse =
                                                await apiService.getApiParamater(
                                                    "GET_REQ_COMMON",
                                                    `?${params.toString()}`
                                                );

                                            vendorExits =
                                                apiResponse?.data?.result?.data?.VendorExits || 0;

                                        } catch (err) {
                                            console.error(err);
                                        }
                                    }

                                    // If ANY supplier for this item exists in PO,
                                    // lock the whole item.
                                    if (vendorExits === 1) {
                                        itemLocked = true;
                                    }

                                    quotations.push({
                                        // IMPORTANT:
                                        // Keep supp1/supp2 as separate slots
                                        supplierIndex: i,

                                        itemCode: item.itemCode,
                                        qty: item.qty,
                                        selected: item[`selected${i}`],
                                        unitPrice: item[`price${i}`],
                                        amount: item.qty * item[`price${i}`],
                                        supplier,
                                        supplierId,
                                        paymentTerms: item[`paymentTerms${i}`],
                                        refNo: item[`ref${i}`],
                                        remarks: item[`remarks${i}`],
                                        vendorExits
                                    });
                                }
                            }

                            debugger

                            return {
                                srno: item.srno,
                                ItemNo: item.itemCode,
                                itemDescription: item.itemDescription,
                                Specs: item.specification,
                                qty: item.qty,
                                uom: item.uom,
                                baseQty: item.qty,
                                baseAmount: item.qty * item.price1,
                                amount: item.qty * item.price1,
                                Delivery: "",
                                bol: "",
                                itemLocked,
                                quotations
                            };
                        })
                    );

                    const transformedFormData = {
                        QuoteNo: data.quoteNo,
                        RequisitionNo: data.requisitionNo,
                        remarks: "",
                        costCenter1: data.costCenter1,
                        costCenter2: data.costCenter2,
                        costCenter3: data.costCenter3,
                        costCenter4: data.costCenter4,
                        quotation: []
                    };

                    // =====================================================
                    // ONLY CHANGE:
                    // supplierIndex identifies supp1/supp2/supp3...
                    // instead of supplier name.
                    // =====================================================
                    const selectedQuotationsMap = new Map();

                    transformedRows.forEach(row => {
                        row.quotations.forEach(quote => {

                            const key = `${quote.itemCode}-${quote.supplierIndex}`;

                            if (
                                !selectedQuotationsMap.has(key) ||
                                quote.selected === 1
                            ) {
                                selectedQuotationsMap.set(key, quote);
                            }
                        });
                    });

                    const quotations = Array.from(
                        selectedQuotationsMap.values()
                    );

                    const supplierSet = new Set();
                    const filteredQuotations = [];

                    quotations.forEach(quote => {

                        // IMPORTANT:
                        // Do NOT use supplier name here.
                        const supplierKey = quote.supplierIndex;

                        if (!supplierSet.has(supplierKey)) {
                            supplierSet.add(supplierKey);
                            filteredQuotations.push(quote);
                        }
                    });

                    transformedFormData.quotation = filteredQuotations;

                    setFormData(transformedFormData);
                    setRows(transformedRows);

                    let attachparam =
                        `?DocNo=${CompareData.quoteNo}&DocType=${"Qutation"}`;

                    const AttachmentResponse =
                        await apiService.getApiParamater(
                            "GET_ATTACHMENT",
                            attachparam
                        );

                    const existingAttachments =
                        AttachmentResponse?.data?.result || [];

                    if (existingAttachments) {
                        setAttachments(
                            mapAttachmentsFromApi(existingAttachments)
                        );

                        setLoading(false)
                    }

                    setLoading(false)

                } catch (error) {
                    setLoading(false)
                    console.error("Error fetching data:", error);
                }
            }

            fetchCompareData();

        } else if (CompareData.doctype === "UpdateComparison") {

            const fetchCompareData = async () => {
                try {
                    setLoading(true)

                    const resonse = await apiService.get('GET_SUPPLIER');
                    setSupplier(resonse?.data?.result);

                    const payResponse = await apiService.get('GET_EPAYMENT');
                    setPayments([
                        { value: null, description: 'None' },
                        ...payResponse?.data?.result
                    ]);

                    let pcParam = `?PCNo=${CompareData.pcNo}`
                    const pcresponse = await apiService.getApiParamater(
                        'GET_PC',
                        pcParam
                    );

                    const selectedPc = pcresponse.data.result?.find(
                        rec => rec.pcNo === CompareData.pcNo
                    )

                    setRequisitionNo(CompareData?.requisitionNo);
                    setQuotationNo(CompareData.pcNo)

                    const data = selectedPc;

                    let param = `?Id=${selectedPc?.requisitionNo}`
                    const response = await apiService.getApiParamater(
                        'GET_PR',
                        param
                    );

                    const selectedPR = response?.data?.result[0]

                    if (selectedPR?.prDetails) {
                        const formattedRows = selectedPR.prDetails.map(detail => ({
                            srno: detail.srno,
                            ItemNo: detail.itemCode,
                            recordId: detail.itemCode,
                            comparisonStatus: data.status,
                            itemDescription: detail.itemDescription,
                            Specs: detail.specification,
                            qty: detail.qty,
                            uom: detail.uom,
                            baseQty: detail.baseQty,
                            baseAmount: detail.baseAmount,
                            amount: detail.amount,
                            deliveryDate: detail.deliveryDate,
                            bol: '',
                            quotations: [{
                                itemCode: detail.itemCode,
                                qty: detail.qty,
                                unitPrice: "",
                                amount: "",
                                supplier: "",
                                paymentTerms: ""
                            },
                            {
                                itemCode: detail.itemCode,
                                qty: detail.qty,
                                unitPrice: "",
                                amount: "",
                                supplier: "",
                                paymentTerms: ""
                            }]
                        }));

                        setRows(formattedRows);
                    }

                    const uniqueSuppliers = new Map();

                    data.priceComparisonDetails.forEach(item => {
                        for (let i = 1; i <= 6; i++) {

                            const supplierName =
                                item[`supp${i}`]?.trim();

                            if (
                                supplierName &&
                                supplierName !== "" &&
                                supplierName !== "string" &&
                                item[`price${i}`] > 0
                            ) {

                                const supplier =
                                    resonse.data.result.find(
                                        s =>
                                            s.supplierName.trim() ===
                                            supplierName
                                    );

                                if (supplier?.supplier_ID) {
                                    uniqueSuppliers.set(
                                        supplier.supplier_ID,
                                        supplier
                                    );
                                }
                            }
                        }
                    });

                    const supplierPoMap = {};

                    await Promise.all(
                        [...uniqueSuppliers.values()].map(async (supplier) => {

                            const params = new URLSearchParams();

                            params.append(
                                "DocNo",
                                CompareData.requisitionNo
                            );

                            params.append(
                                "Commontext",
                                supplier.supplier_ID
                            );

                            params.append(
                                "Action",
                                "CheckSupplierExitsInPoForPC"
                            );

                            try {
                                const response =
                                    await apiService.getApiParamater(
                                        "GET_REQ_COMMON",
                                        `?${params.toString()}`
                                    );

                                supplierPoMap[supplier.supplier_ID] =
                                    response?.data?.result?.data;

                            } catch (err) {
                                console.error(
                                    `Supplier ${supplier.supplier_ID}`,
                                    err
                                );

                                supplierPoMap[supplier.supplier_ID] = 0;
                            }
                        })
                    );

                    // Get all item codes that already exist in any PO
                    const lockedItemCodes = new Set();

                    Object.values(supplierPoMap).forEach(value => {

                        if (Array.isArray(value)) {

                            value.forEach(item => {

                                if (item?.ItemCode?.trim()) {
                                    lockedItemCodes.add(
                                        item.ItemCode.trim()
                                    );
                                }
                            });
                        }
                    });

                    const transformedRows = await Promise.all(
                        data.priceComparisonDetails.map(async (item) => {

                            const quotations = [];

                            // If this item exists in any supplier PO,
                            // lock it for every supplier.
                            const isLocked =
                                lockedItemCodes.has(
                                    item.itemCode.trim()
                                ) ? 0 : 1;

                            for (let i = 1; i <= 6; i++) {

                                const supplier =
                                    item[`supp${i}`]?.trim();

                                if (supplier) {

                                    const selectedSupplier =
                                        resonse.data.result.find(
                                            rec =>
                                                rec.supplierName.trim() ===
                                                supplier
                                        );

                                    const supplierData =
                                        supplierPoMap[
                                        selectedSupplier?.supplier_ID
                                        ];

                                    const supplierLock =
                                        Array.isArray(supplierData)
                                            ? supplierData.some(
                                                x => x.VendorExits === 1
                                            ) ? 0 : 1
                                            : supplierData?.VendorExits === 1
                                                ? 0
                                                : 1;

                                    quotations.push({
                                        // IMPORTANT:
                                        // Keep supp1/supp2 separate.
                                        supplierIndex: i,

                                        itemCode: item.itemCode,
                                        qty: item.qty,
                                        selected:
                                            item[`selected${i}`] || 0,
                                        unitPrice:
                                            item[`price${i}`] || 0,
                                        amount:
                                            item.qty *
                                            item[`price${i}`],
                                        supplier,
                                        supplierId:
                                            selectedSupplier?.supplier_ID,
                                        paymentTerms:
                                            item[`paymentTerms${i}`],
                                        refNo:
                                            item[`ref${i}`],
                                        remarks:
                                            item[`remarks${i}`],
                                        isLocked,
                                        supplierLock
                                    });
                                }
                            }

                            return {
                                srno: item.srno,
                                ItemNo: item.itemCode,
                                itemDescription: item.itemDescription,
                                Specs: item.specification,
                                qty: item.qty,
                                uom: item.uom,
                                baseQty: item.qty,
                                baseAmount: item.qty * item.price1,
                                amount: item.qty * item.price1,
                                Delivery: "",
                                bol: "",
                                quotations
                            };
                        })
                    );

                    const transformedFormData = {
                        QuoteNo: data.quoteNo,
                        RequisitionNo: data.requisitionNo,
                        remarks: "",
                        costCenter1: data.costCenter1,
                        costCenter2: data.costCenter2,
                        costCenter3: data.costCenter3,
                        costCenter4: data.costCenter4,
                        quotation: []
                    };

                    // =====================================================
                    // ONLY CHANGE:
                    // Use supplierIndex for duplicate supplier slots.
                    // =====================================================
                    const selectedQuotationsMap = new Map();

                    transformedRows.forEach(row => {
                        row.quotations.forEach(quote => {

                            const key =
                                `${quote.itemCode}-${quote.supplierIndex}`;

                            if (
                                !selectedQuotationsMap.has(key) ||
                                quote.selected === 1
                            ) {
                                selectedQuotationsMap.set(
                                    key,
                                    quote
                                );
                            }
                        });
                    });

                    const quotations = Array.from(
                        selectedQuotationsMap.values()
                    );

                    const supplierSet = new Set();
                    const filteredQuotations = [];

                    quotations.forEach(quote => {

                        const supplierKey =
                            quote.supplierIndex;

                        if (!supplierSet.has(supplierKey)) {
                            supplierSet.add(supplierKey);
                            filteredQuotations.push(quote);
                        }
                    });

                    transformedFormData.quotation =
                        filteredQuotations;

                    setFormData(transformedFormData);
                    setRows(transformedRows);

                    let attachparam =
                        `?DocNo=${CompareData.quoteNo}&DocType=${"Qutation"}`;

                    const AttachmentResponse =
                        await apiService.getApiParamater(
                            "GET_ATTACHMENT",
                            attachparam
                        );

                    const existingAttachments =
                        AttachmentResponse?.data?.result || [];

                    if (existingAttachments) {
                        setAttachments(
                            mapAttachmentsFromApi(existingAttachments)
                        );

                        setLoading(false)
                    }

                    setLoading(false)

                } catch (error) {
                    console.error("Error fetching data:", error);
                    setLoading(false)
                }
            }

            fetchCompareData();

        } else {

            const fetchCompareData = async () => {
                try {

                    const pcresponse =
                        await apiService.get('GET_QUOTATION');

                    const selectedPc =
                        pcresponse.data.result?.find(
                            rec => rec.quoteNo === CompareData.docno
                        )

                    setRequisitionNo(selectedPc?.requisitionNo);
                    setQuotationNo(CompareData?.docno)

                    const data = selectedPc;

                    let param =
                        `?Id=${selectedPc.requisitionNo}`

                    const response =
                        await apiService.getApiParamater(
                            'GET_PR',
                            param
                        );

                    const selectedPR =
                        response?.data?.result[0]

                    if (selectedPR?.prDetails) {

                        const formattedRows =
                            selectedPR.prDetails.map(detail => ({
                                srno: detail.srno,
                                ItemNo: detail.itemCode,
                                recordId: detail.itemCode,
                                comparisonStatus: data.status,
                                itemDescription: detail.itemDescription,
                                Specs: detail.specification,
                                qty: detail.qty,
                                uom: detail.uom,
                                baseQty: detail.baseQty,
                                baseAmount: detail.baseAmount,
                                amount: detail.amount,
                                deliveryDate: detail.deliveryDate,
                                bol: '',
                                quotations: [{
                                    itemCode: detail.itemCode,
                                    qty: detail.qty,
                                    unitPrice: "",
                                    amount: "",
                                    supplier: "",
                                    paymentTerms: ""
                                },
                                {
                                    itemCode: detail.itemCode,
                                    qty: detail.qty,
                                    unitPrice: "",
                                    amount: "",
                                    supplier: "",
                                    paymentTerms: ""
                                }]
                            }));

                        setRows(formattedRows);
                    }

                    const transformedRows =
                        data.tempQuotationDetails.map(item => {

                            const quotations = [];

                            for (let i = 1; i <= 6; i++) {

                                let supplier =
                                    item[`supp${i}`]?.trim();

                                if (
                                    !supplier ||
                                    supplier === "string"
                                ) {
                                    continue;
                                }

                                quotations.push({
                                    // IMPORTANT:
                                    // Keep supp1 and supp2 separate.
                                    supplierIndex: i,

                                    itemCode: item.itemCode,
                                    qty: item.qty,
                                    selected:
                                        item[`selected${i}`],
                                    unitPrice:
                                        item[`price${i}`],
                                    amount:
                                        item.qty *
                                        item[`price${i}`],
                                    supplier: supplier,
                                    paymentTerms:
                                        item[`paymentTerms${i}`],
                                    refNo:
                                        item[`ref${i}`],
                                    remarks:
                                        item[`remarks${i}`]
                                });
                            }

                            return {
                                srno: item.srno,
                                ItemNo: item.itemCode,
                                itemDescription:
                                    item.itemDescription,
                                Specs: item.specification,
                                qty: item.qty,
                                uom: item.uom,
                                baseQty: item.qty,
                                baseAmount:
                                    item.qty *
                                    item.price1,
                                amount:
                                    item.qty *
                                    item.price1,
                                Delivery: "",
                                bol: '',
                                quotations: quotations
                            };
                        });

                    const transformedFormData = {
                        QuoteNo: data.quoteNo,
                        RequisitionNo: data.requisitionNo,
                        remarks: "",
                        costCenter1: data.costCenter1,
                        costCenter2: data.costCenter2,
                        costCenter3: data.costCenter3,
                        costCenter4: data.costCenter4,
                        quotation: []
                    };

                    // =====================================================
                    // ONLY CHANGE:
                    // supplierIndex is now used so duplicate suppliers
                    // in supp1/supp2 are not merged.
                    // =====================================================
                    const selectedQuotationsMap = new Map();

                    transformedRows.forEach(row => {
                        row.quotations.forEach(quote => {

                            const key =
                                `${quote.itemCode}-${quote.supplierIndex}`;

                            if (
                                !selectedQuotationsMap.has(key) ||
                                quote.selected === 1
                            ) {
                                selectedQuotationsMap.set(
                                    key,
                                    quote
                                );
                            }
                        });
                    });

                    const quotations = Array.from(
                        selectedQuotationsMap.values()
                    );

                    const supplierSet = new Set();
                    const filteredQuotations = [];

                    quotations.forEach(quote => {

                        const supplierKey =
                            quote.supplierIndex;

                        if (!supplierSet.has(supplierKey)) {
                            supplierSet.add(supplierKey);
                            filteredQuotations.push(quote);
                        }
                    });

                    transformedFormData.quotation =
                        filteredQuotations;

                    setFormData(transformedFormData);
                    setRows(transformedRows);

                    let attachparam =
                        `?DocNo=${CompareData.docno}&DocType=${"Qutation"}`;

                    const AttachmentResponse =
                        await apiService.getApiParamater(
                            "GET_ATTACHMENT",
                            attachparam
                        );

                    const existingAttachments =
                        AttachmentResponse?.data?.result || [];

                    if (existingAttachments) {
                        setAttachments(
                            mapAttachmentsFromApi(
                                existingAttachments
                            )
                        );

                        setLoading(false)
                    }

                    setLoading(false)

                } catch (error) {
                    setLoading(false)
                    console.error(
                        "Error fetching data:",
                        error
                    );
                }
            }

            fetchCompareData();
        }

    }, [location.state, CompareData]);

    const calculateSubtotals = () => {
        const totals = {};
        rows.forEach(row => {
            row.quotations.forEach(quotation => {
                if (quotation.selected === 1) {
                    if (!totals[quotation.supplier]) {
                        totals[quotation.supplier] = 0;
                    }
                    totals[quotation.supplier] += quotation.amount;
                }
            });
        });
        setSuppliersTotals(totals);
    };

    useEffect(() => {
        calculateSubtotals();
    }, [rows]);

    useEffect(() => {
        const item = location.state;
        if (item?.prDetails) {
            const formattedRows = item.prDetails.map(detail => ({
                srno: detail.srno,
                ItemNo: detail.itemCode,
                recordId: detail.itemCode,
                comparisonStatus: item.comparisonStatus,
                itemDescription: detail.itemDescription,
                Specs: detail.specification,
                qty: detail.qty,
                uom: detail.uom,
                baseQty: detail.baseQty,
                baseAmount: detail.baseAmount,
                amount: detail.amount,
                deliveryDate: detail.deliveryDate,
                bol: '',
                quotations: [{
                    itemCode: detail.itemCode,
                    qty: detail.qty,
                    unitPrice: "",
                    amount: "",
                    supplier: "",
                    paymentTerms: ""
                }]
            }));
            setRows(formattedRows);
        }
    }, [location.state]);

    useEffect(() => {
        const supplierContainer = supplierContainerRef.current;
        const itemsContainer = itemsContainerRef.current;

        if (!supplierContainer || !itemsContainer) return;

        const handleSupplierScroll = () => {
            if (scrollSyncRef.current !== 'items') {
                scrollSyncRef.current = 'supplier';
                itemsContainer.scrollLeft = supplierContainer.scrollLeft;
            }
        };

        const handleItemsScroll = () => {
            if (scrollSyncRef.current !== 'supplier') {
                scrollSyncRef.current = 'items';
                supplierContainer.scrollLeft = itemsContainer.scrollLeft;
            }
        };

        supplierContainer.addEventListener('scroll', handleSupplierScroll);
        itemsContainer.addEventListener('scroll', handleItemsScroll);

        return () => {
            supplierContainer.removeEventListener('scroll', handleSupplierScroll);
            itemsContainer.removeEventListener('scroll', handleItemsScroll);
        };
    }, []);

    const supplierTotals = {};
    rows?.forEach(row => {
        row.quotations.forEach(quotation => {
            const supplierName = quotation.supplier;
            if (!supplierTotals[supplierName]) {
                supplierTotals[supplierName] = { qty: 0, amount: 0 };
            }
            supplierTotals[supplierName].qty += quotation.qty;
            supplierTotals[supplierName].amount += quotation.amount;
        });
    });
    const handleBackClick = () => {
        window.history.back();
    }
    const handleCheckboxChange = (rowIndex, quotationIndex, checked) => {
        const updatedRows = [...rows];
        updatedRows[rowIndex].quotations.forEach((quotation, index) => {
            quotation.selected = 0;
        });
        if (checked) {
            updatedRows[rowIndex].quotations[quotationIndex].selected = 1;
        }
        setRows(updatedRows);
    };
    const UpdateComaprison = async () => {
        try {
            setloader(true)
            const currentDatetimeUTC = new Date().toISOString();
            const maxQuotations = 6;
            if (formData.quotation[0].supplier.length === 0) {
                toast.error("Please select suppliers before creating the quotation.");
                setloader(true)
                return;
            }
            const hasSelectedQuotation = rows.every(item =>
                item.quotations.some(quotation => quotation.selected === 1)
            );

            if (!hasSelectedQuotation) {
                toast.error("Each item must have at least one selected quotation.");
                setloader(false);
                return;
            }

            const itemDetails = rows?.map((item, index) => {
                const itembody = {
                    srno: index + 1,
                    itemCode: item.ItemNo,
                    itemDescription: item.itemDescription,
                    uom: item.uom,
                    qty: item.qty,
                }
                item?.quotations.forEach((quotation, index) => {
                    if (index >= maxQuotations) {
                        toast.error(`Quotation limit exceeded for item ${item.ItemNo}. Maximum allowed is ${maxQuotations}.`);
                        setloader(false)
                        return;
                    }
                    const suffix = index + 1;
                    itembody[`supp${suffix}`] = quotation.supplier || "";
                    itembody[`ref${suffix}`] = quotation?.refNo || "";
                    itembody[`remarks${suffix}`] = quotation?.remarks || "";
                    itembody[`paymentTerms${suffix}`] = quotation.paymentTerms || "";
                    itembody[`price${suffix}`] = quotation.unitPrice || 0;
                    itembody[`selected${suffix}`] = quotation.selected || 0;
                    itembody[`suppId${suffix}`] = quotation.supplierId || "";
                });
                for (let i = item.quotations.length + 1; i <= maxQuotations; i++) {
                    itembody[`supp${i}`] = "";
                    itembody[`ref${i}`] = "";
                    itembody[`remarks${i}`] = "";
                    itembody[`paymentTerms${i}`] = "";
                    itembody[`price${i}`] = 0;
                    itembody[`selected${i}`] = 0;
                    itembody[`suppId${i}`] = "";
                }
                return itembody;
            });

            const calculateTotalPrice = (itemDetails) => {
                let totalAmount = 0;
                itemDetails.forEach(item => {
                    for (let i = 1; i <= 6; i++) {
                        if (item[`selected${i}`] === 1) {
                            totalAmount += item[`price${i}`] * item.qty;
                        }
                    }
                });
                return totalAmount;
            };
            const totalAmount = calculateTotalPrice(itemDetails);
            const requestBody = {
                pcid: CompareData.pcid,
                pcDate: new Date().toISOString(),
                modifiedBy: userName,
                status: 0,
                pcNo: CompareData?.pcNo,
                requisitionNo: CompareData?.requisitionNo,
                quoteNo: CompareData?.quoteNo,
                costCenter1: CompareData.costCenter1,
                costCenter2: CompareData.costCenter2,
                costCenter3: CompareData.costCenter3,
                costCenter4: CompareData.costCenter4,
                amount: totalAmount,
                priceComparisonDetails: itemDetails
            };
            const response = await apiService.put("UPDATE_PC", requestBody);
            if (response?.data?.statusCode === 201) {
                dispatch(clearComparison());
                const userData2 = {
                    docId: QuotationNo,
                    department: "IT",
                    docType: "Price Comparison",
                    company: Company?.selectedCompany?.companyNo,
                    userCode: userId,
                    userName: userName,
                };
                const docBody = {
                    docId: "Price Comparison",
                    typeOfDoc: "PC"
                }
                const response2 = await apiService.post("CREATE_DOC_AUTHORIZATION", userData2);
                const paramsGet = new URLSearchParams();
                paramsGet.append('docType', "Price Comparison");
                paramsGet.append('docId', QuotationNo);
                paramsGet.append('srno', 1);
                const response3 = await apiService.getApiParamater('GET_DOC_APPROVAL_USER', `?${paramsGet.toString()}`);
                // if (response3?.data?.result.length > 0) {
                //     const toEmails = response3?.data?.result?.map(user => user.userEmail);
                //     const emailbody = {
                //         toEmails: toEmails,
                //         subject: "Price Comparison",
                //         body: "",
                //         docNo: QuotationNo,
                //         srNo: 1,
                //         docType: "Price Comparison"
                //     };
                //     const emailres = await apiService.post("DOC_APPROVAL_EMAIL_POST", emailbody);
                // }
                toast.success(` ${QuotationNo} Updated successfully`);
                setloader(false)
                dispatch(clearComparison());
                navigate("/inventory/PriceComparison/List");
            }
            setloader(false)

        } catch (error) {
            setloader(false)
            console.error("Error Creating Comparison:", error);
        }
    };
    // Attachment Functions
    const handleFileSelect = (file, id) => {
        setAttachments(prev => {
            const updated = prev.map(row =>
                row.id === id
                    ? {
                        ...row,
                        file,
                        fileName: file.name,
                        isNew: true
                    }
                    : row
            );

            return [...updated, createEmptyRow()];
        });
    };
    const handleRemarkChange = (id, value) => {
        setAttachments(prev =>
            prev.map(row =>
                row.id === id ? { ...row, remarks: value } : row
            )
        );
    };
    const handleDelete = (id) => {
        setAttachments(prev =>
            prev.map(row =>
                row.id === id
                    ? { ...row, isDeleted: true }
                    : row
            )
        );
    }
    const handleView = (file) => {
        if (!file) return;
        if (file?.isNew === false) {
            setPreviewImage(file?.fileName);
        } else {
            setPreviewImage(URL.createObjectURL(file?.file));
        }
        setPreview(file)
        setPreviewModal(true);
    };
    const handleTableChange = (rowIndex, quotationIndex, field, value) => {
        if (value < 0) {
            return;
        }
        setRows(prevRows => {
            const updatedRows = [...prevRows];
            const updatedQuotations = [...updatedRows[rowIndex].quotations];
            updatedQuotations[quotationIndex] = {
                ...updatedQuotations[quotationIndex],
                [field]: value
            };

            if (field === 'unitPrice') {
                const qty = updatedQuotations[quotationIndex].qty;
                updatedQuotations[quotationIndex].amount = value * qty;
            }

            updatedRows[rowIndex] = {
                ...updatedRows[rowIndex],
                quotations: updatedQuotations
            };

            return updatedRows;
        });
    };
    const preventNegativeSign = (e) => {
        if (e.key === "-" || e.key === "+") {
            e.preventDefault();
        }
    };
    const handleQuotationChange = (index, e) => {
        const { id, value } = e.target;
        setFormData(prevFormData => {
            const updatedQuotations = [...prevFormData.quotation];
            updatedQuotations[index] = {
                ...updatedQuotations[index],
                [id.replace(/\d+/, '')]: value
            };
            return { ...prevFormData, quotation: updatedQuotations };
        });

        setRows(prevRows => {
            const updatedRows = [...prevRows];
            updatedRows.forEach(row => {
                if (row.quotations[index]) {
                    row.quotations[index][id.replace(/\d+/, '')] = value;
                }
            });
            return updatedRows;
        });
    };
    const handleSupChange = (selectedOption, index) => {
        const selectedSupplier = selectedOption.value;
        const supplierData = suppliers.find(sup => sup.supplierName === selectedSupplier);
        const defaultPaymentTerm = payments.find(pay => pay.description === supplierData?.paymentTerm);
        const supplierAlreadySelected = formData.quotation.some(quotation => quotation.supplier === selectedOption.label);
        // if (supplierAlreadySelected) {
        //     toast.warning('Supplier already selected');
        //     return;
        // }

        setFormData(prevFormData => {
            const updatedQuotations = [...prevFormData.quotation];
            updatedQuotations[index] = {
                ...updatedQuotations[index],
                supplier: selectedOption?.label,
                supplierId: supplierData?.supplier_ID,
                paymentTerms: defaultPaymentTerm?.description || null
            };
            return { ...prevFormData, quotation: updatedQuotations };
        });
        setRows(prevRows => {
            const updatedRows = [...prevRows];
            updatedRows.forEach(row => {
                if (row.quotations[index]) {
                    row.quotations[index].supplier = selectedOption?.label;
                    row.quotations[index].supplierId = supplierData?.supplier_ID;
                    row.quotations[index].paymentTerms = defaultPaymentTerm?.description || null;
                }
            });
            return updatedRows;
        });
    };
    const handleAddRow = () => {

        setFormData(prevFormData => ({
            ...prevFormData,
            quotation: [...prevFormData.quotation, { refNo: '', payment: '', supplier: '', remarks: '', supplierLock: 1 }],
        }));

        setRows(prevRows => prevRows.map(row =>

        ({
            ...row,
            quotations: [...row.quotations,
            {
                itemCode: row.itemCode,
                qty: row.qty,
                unitPrice: 0,
                amount: "",
                supplier: "",
                paymentTerms: "",
                isLocked: row.quotations?.[0]?.isLocked ?? 0,
                supplierLock: 1,
            }]
        })));
    };
    const handleDeleteQuotation = (index) => {
        setFormData(prevFormData => {
            const updatedQuotations = prevFormData.quotation.filter((_, i) => i !== index);
            return { ...prevFormData, quotation: updatedQuotations };
        });

        setRows(prevRows => prevRows.map(row => ({
            ...row,
            quotations: row.quotations.filter((_, i) => i !== index)
        })));
    };
    const handlePaymentTermChange = (selectedOption, index) => {
        setFormData(prevFormData => {
            const updatedQuotations = [...prevFormData.quotation];
            updatedQuotations[index] = {
                ...updatedQuotations[index],
                paymentTerms: selectedOption?.label
            };
            return { ...prevFormData, quotation: updatedQuotations };
        });

        setRows(prevRows => {
            const updatedRows = [...prevRows];
            updatedRows.forEach(row => {
                if (row.quotations[index]) {
                    row.quotations[index].paymentTerms = selectedOption?.label;
                }
            });
            return updatedRows;
        });

    };
    return (
        <div className='p-4'>
            {loading && (
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        background: 'rgba(255,255,255,0.6)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10,
                    }}
                >
                    <div className="spinner-border text-primary" role="status" />
                </div>
            )}
            <div className='d-flex gap-3 end'>
                {CompareData.doctype === "UpdateComparison" ?
                    <>{loader === true ?
                        <button className='mainbtn'><ClipLoader size={25} color='#fff' /></button> :
                        <button className='mainbtn ' type="submit" onClick={UpdateComaprison}>
                            <FaSave className='center mt-1 mx-2' /><div>Save</div>
                        </button>
                    }</> : ""
                }
                <div className=''>
                    <button onClick={handleBackClick} className='mainbtn'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                </div>
            </div>
            <div className="cost-center-section mb-2">
                <div className="d-flex mt-3 cursor-pointer slide-header gap-4"
                    onClick={() => setSupplierTab(!SupplierTab)}>
                    <div className='h6 pt-1'>Comparison Details</div>
                </div>
                <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className='row'>
                            <div className='col-5'>
                                <div className="d-flex justify-content-between">
                                    <label htmlFor="QuoteNo" className="form-label  pt-2 start">PC No</label>
                                    <input className="form-Input w-100" value={QuotationNo ? `${QuotationNo}` : " "} disabled />
                                </div>
                                <div className="py-2 d-flex justify-content-between">
                                    <label htmlFor="RequisitionNo" className="form-label  pt-2 start">Requisition No</label>
                                    <input disabled className="form-Input w-100" value={RequisitionNo} />
                                </div>
                                <div className="d-flex justify-content-between">
                                    <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Property</label>
                                    <input disabled className="form-Input w-100" value={CompareData.costCenter1 || formData.costCenter1} />
                                </div>
                                <div className="py-2 d-flex justify-content-between">
                                    <label htmlFor="Property" className="form-label  pt-2 start">Unit</label>
                                    <input disabled className="form-Input w-100" value={CompareData.costCenter2 || formData.costCenter2} />
                                </div>
                                <div className="d-flex justify-content-between">
                                    <label htmlFor="Department" className="form-label  pt-2 start">Cost Center 3</label>
                                    <input disabled className="form-Input w-100" value={CompareData.costCenter3 || formData.costCenter3} />
                                </div>
                                <div className="pt-2 d-flex justify-content-between">
                                    <label htmlFor="Outlet" className="form-label  pt-2 start">Cost Center 4</label>
                                    <input disabled className="form-Input w-100" value={CompareData.costCenter4 || formData.costCenter4} />
                                </div>
                            </div>
                            <div className='col-7'>
                                <div className='d-flex gap-3'>
                                    <div className='brderbox px-3 center' style={{ cursor: 'pointer', minHeight: '40px' }}
                                        onClick={() => handleOpen()}><a >Attachment</a></div>
                                    {CompareData?.doctype === "Comparison" ?
                                        <div className="" style={{ cursor: "not-allowed" }}><button className="mainbtn" disabled style={{ cursor: "not-allowed" }}>Add More</button></div> :
                                        <div className="">
                                            <button className="mainbtn" onClick={handleAddRow}>Add More</button>
                                        </div>
                                    }
                                </div>

                                <div ref={supplierContainerRef} className="d-flex mt-2 gap-3 ovrflo">
                                    {formData?.quotation?.map((quotation, index) => {
                                        const isLocked = quotation?.supplierLock === 0;
                                        return (
                                            <div key={index} className="col-md-4 col-lg-3 quotationbox py-3 px-2">
                                                {CompareData.doctype === "Comparison" ?
                                                    <div className='d-flex justify-content-between pb-1'>
                                                        <label className="form-label">Supplier</label>
                                                        <RxCross2 />
                                                    </div> :
                                                    <div className='d-flex justify-content-between pb-1'>
                                                        <label className="form-label">Supplier</label>
                                                        <RxCross2 onClick={() => handleDeleteQuotation(index)} />
                                                    </div>
                                                }
                                                <div className='d-flex justify-content-between'>
                                                    <Select theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 5,
                                                        padding: 9
                                                    })}
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                            option: (provided, state) => ({
                                                                ...provided,
                                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                                color: state.isFocused ? '#000 ' : '#000',
                                                                ':hover': {
                                                                    backgroundColor: '#F5F5F5',
                                                                    color: '#000 ',
                                                                },
                                                            }),
                                                        }}
                                                        className="p-0 w-100 "
                                                        isDisabled={CompareData.doctype === "Comparison" || isLocked}
                                                        value={quotation?.supplier ? { value: quotation?.supplier, label: quotation?.supplier } : { label: "Select Supplier", value: "Select Supplier" }}
                                                        onChange={(selectedOption) => handleSupChange(selectedOption, index)}
                                                        options={suppliers?.map((sup) => ({ value: sup?.supplierName, label: sup?.supplierName }))}
                                                    />
                                                </div>
                                                <div className="my-2 d-flex justify-content-between">
                                                    <Select theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 5,
                                                        padding: 9
                                                    })}
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                            option: (provided, state) => ({
                                                                ...provided,
                                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                                color: state.isFocused ? '#000 ' : '#000',
                                                                ':hover': {
                                                                    backgroundColor: '#F5F5F5',
                                                                    color: '#000 ',
                                                                },
                                                            }),
                                                        }}
                                                        className="p-0 w-100 "
                                                        isDisabled={CompareData.doctype === "Comparison" || isLocked}
                                                        options={payments?.map((pay) => ({ value: pay?.description, label: pay?.description }))}
                                                        onChange={(selectedOption) => handlePaymentTermChange(selectedOption, index)}
                                                        value={quotation?.paymentTerms ? { value: quotation?.paymentTerms, label: quotation?.paymentTerms } : { label: "Select Payment Term", value: "Select Supplier" }}
                                                    />
                                                </div>
                                                <div className="d-flex justify-content-between">
                                                    <input
                                                        type="text" onWheel={(e) => e.target.blur()}
                                                        className="form-Input w-100 "
                                                        id={`refNo${index}`}
                                                        value={quotation.refNo}
                                                        disabled={CompareData.doctype === "Comparison" || isLocked}
                                                        onChange={(e) => handleQuotationChange(index, e)}
                                                        placeholder="Quotation Ref No"
                                                    />
                                                </div>
                                                <div className="d-flex justify-content-between mt-2">
                                                    <textarea
                                                        className="form-Input w-100 "
                                                        id={`remarks${index}`}
                                                        disabled={CompareData.doctype === "Comparison" || isLocked}
                                                        onChange={(e) => handleQuotationChange(index, e)}
                                                        placeholder="Remarks"
                                                        value={quotation.remarks}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header gap-4"
                    onClick={() => setCostTab(!CostTab)}>
                    <div className='h6 pt-1'>Items Details</div>
                </div>
                <div className={`slide-content ${CostTab ? 'open' : 'closed'}`}>
                    <div className="border-box2">
                        <div className="grid-1" onMouseLeave={() => scrollSyncRef.current = null}>
                            <div ref={itemsContainerRef} className='table-container mb-5' style={{ overflowX: 'auto', height: "auto" }}>
                                <table>
                                    <thead className='dynoTable' >
                                        <tr>
                                            <th>Sr no</th>
                                            <th>Item No</th>
                                            <th>Description</th>
                                            <th>Item Specs</th>
                                            <th>UOM</th>
                                            <th>Delivery Date</th>
                                            {rows[0]?.quotations.map((_, index) => (
                                                <React.Fragment key={index}>
                                                    <th></th>
                                                    <th>Qty</th>
                                                    <th>Unit Price</th>
                                                    <th>Amount</th>
                                                </React.Fragment>
                                            ))}
                                        </tr>
                                    </thead>
                                    {!rows ?
                                        <div>
                                            <ClipLoader size={50} color='#5B93FF' />
                                        </div> :
                                        <tbody>
                                            {rows?.map((row, index) => (
                                                <tr key={index}>
                                                    <td className='m-0 p-0'><input style={{ width: "58px" }} className='p-1' type="number" disabled value={index + 1} /></td>
                                                    <td className='m-0 p-0'><input style={{ width: "78px" }} className='p-1' type="text" disabled value={row.ItemNo} /></td>
                                                    <td className='m-0 p-0'><input className='p-1' type="text" disabled value={row.itemDescription} /></td>
                                                    <td className='m-0 p-0'><input style={{ width: "101px" }} className='p-1' type="text" disabled value={row.Specs} /></td>
                                                    <td className='m-0 p-0'><input style={{ width: "90px" }} className='p-1' type="text" disabled value={row.uom} /></td>
                                                    <td className='m-0 p-0'><input style={{ width: "118px" }} className='p-1' disabled value={moment(CompareData?.deliveryDate).format('L')} /></td>
                                                    {row?.quotations.map((q, quotationIndex) => (
                                                        <React.Fragment key={quotationIndex}>
                                                            <td>
                                                                <div className='center'>
                                                                    {CompareData.doctype === "UpdateComparison" ?
                                                                        <input
                                                                            className='px-2 form-check-input'
                                                                            type="checkbox"
                                                                            disabled={q.isLocked === 0 ? true : false}
                                                                            style={{ width: "20px", height: "20px" }}
                                                                            checked={q.selected === 1}
                                                                            onChange={(e) => handleCheckboxChange(index, quotationIndex, e.target.checked)}
                                                                        /> :
                                                                        <input
                                                                            className='px-2 form-check-input'
                                                                            checked={q.selected === 1}
                                                                            type="checkbox" disabled
                                                                            style={{ width: "20px", height: "20px" }}
                                                                        />}
                                                                </div>
                                                            </td>
                                                            <td><input style={{ width: "55px" }} className='p-1' type="text" disabled value={q.qty} /></td>
                                                            <td>
                                                                <input
                                                                    style={{ width: "88px" }} disabled={CompareData.doctype === "Comparison" || q.isLocked === 0 ? true : false}
                                                                    className='p-1' type="number" onWheel={(e) => e.target.blur()}
                                                                    value={q.unitPrice} min={0} onKeyDown={preventNegativeSign}
                                                                    onChange={(e) => handleTableChange(index, quotationIndex, 'unitPrice', e.target.value)}
                                                                />
                                                            </td>
                                                            {/* <td><input style={{ width: "88px" }} className='p-1' type="text" value={Number(q.unitPrice).toFixed(currencyPrecision?.exp1 || 3)} disabled /></td> */}
                                                            <td><input style={{ width: "88px" }} className='p-1' type="text" disabled value={Number(q.amount || 0).toFixed(currencyPrecision?.exp1 || 3)} /></td>
                                                        </React.Fragment>
                                                    ))}
                                                </tr>
                                            ))}
                                            <tr>
                                                <td colspan="6" className='m-0 p-0'><input className='p-1 w-100' disabled value={"Total"} /></td>
                                                {Object.keys(supplierTotals).map((supplier, index) => (
                                                    <React.Fragment key={index}>
                                                        <td><input style={{ width: "35px" }} className='p-1' type="text" disabled value={""} /></td>
                                                        <td><input style={{ width: "55px" }} className='p-1' type="text" disabled value={supplierTotals[supplier].qty} /></td>
                                                        <td><input style={{ width: "88px" }} className='p-1' type="text" disabled value={"--"} /></td>
                                                        <td><input style={{ width: "88px" }} className='p-1' type="text" disabled value={Number(supplierTotals[supplier].amount || "0").toFixed(currencyPrecision?.exp1 || 3)} /></td>
                                                    </React.Fragment>
                                                ))}
                                            </tr>
                                            <tr>
                                                <td colspan="6" className='m-0 p-0'><input className='p-1 w-100' disabled value={"Supplier Total"} /></td>
                                                {Object.keys(supplierTotals).map((supplier, index) => (
                                                    <React.Fragment key={index}>
                                                        <td><input style={{ width: "35px" }} className='p-1' type="text" disabled value={""} /></td>
                                                        <td><input style={{ width: "55px" }} className='p-1' type="text" disabled value={""} /></td>
                                                        <td><input style={{ width: "88px" }} className='p-1' type="text" disabled value={""} /></td>
                                                        <td><input style={{ width: "88px" }} className='p-1' type="text" disabled value={Number(suppliersTotals[supplier] || "0").toFixed(currencyPrecision?.exp1 || 3)} /></td>
                                                    </React.Fragment>
                                                ))}
                                            </tr>
                                        </tbody>
                                    }
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <UpdateAttachment
                documentNo={QuotationNo}
                open={attachmentModal}
                rows={attachments}
                readOnly={CompareData?.eye}
                onFileSelect={handleFileSelect}
                onRemarkChange={handleRemarkChange}
                onDelete={handleDelete}
                onClose={closeModal}
            />
        </div>
    )
}

export default PriceCompView